import { QueryCache, QueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

// Queries opt into an error toast with `meta: { errorMessage }`, so pages
// don't each need their own error effect.
const queryCache = new QueryCache({
  onError: (error, query) => {
    console.error(error);
    if (query.meta?.errorMessage) toast.error(query.meta.errorMessage);
  },
});

export const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      // Alert review is collaborative: after 30s, revisiting a page or
      // refocusing the tab refetches in the background.
      staleTime: 30 * 1000,
      // One retry, so a real failure still surfaces within a few seconds.
      retry: 1,
    },
  },
});
